// extracted by mini-css-extract-plugin
export var container = "style-module--container--76cad";
export var logo = "style-module--logo--c43db";
export var menu = "style-module--menu--88109";
export var nav = "style-module--nav--d7e0e";
export var nav_container = "style-module--nav_container--0f219";
export var nav_copyright = "style-module--nav_copyright--1bbe1";
export var nav_item = "style-module--nav_item--1e669";
export var nav_item_emphasis = "style-module--nav_item_emphasis--09848";
export var nav_list = "style-module--nav_list--79a33";
export var nav_open = "style-module--nav_open--46d58";